import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, ErrorMessage } from 'formik';
import ErrorRow from './ErrorRow';
import InputField from '../InputField';
import Switcher from '../Switcher';

const OpeningTimesRow = ({ day, open, close, isOpen, isEditing }) => {
  return (
    <React.Fragment>
      <tr className="DealeroOpeningTimes__table-row">
        <FormattedMessage id={day} defaultMessage={day} tagName="td" />
        {!isOpen ? (
          <td className="DealerOpeningTimes__closed-column" colSpan="3">
            <FormattedMessage id="admin.editOpeningTimes.closed" />
          </td>
        ) : (
          <React.Fragment>
            <td className="DealerOpeningTimes__table-column">
              <InputField
                name={`${day}.open`}
                isBorderless={!isEditing}
                readOnly={!isEditing}
                classes={{
                  input: 'DealerOpeningTimes__hour-input',
                }}
                placeholder="00:00"
                mask="11:11"
                value={open}
              />
            </td>

            <FormattedMessage id="to" tagName="td" />

            <td>
              <InputField
                name={`${day}.close`}
                isBorderless={!isEditing}
                readOnly={!isEditing}
                classes={{
                  input: 'DealerOpeningTimes__hour-input',
                }}
                placeholder="00:00"
                mask="11:11"
                value={close}
              />
            </td>
          </React.Fragment>
        )}

        <td>
          <Field
            name={`${day}.isOpen`}
            render={({ field: { name, value, onChange, onBlur } }) => (
              <Switcher
                name={name}
                checked={value}
                onChange={onChange}
                onBlur={onBlur}
                disabled={!isEditing}
              />
            )}
          />
        </td>
      </tr>

      <ErrorMessage
        name={`${day}.open`}
        render={msg => (
          <ErrorRow
            msg={
              <React.Fragment>
                <FormattedMessage id="opens_at" />:
                <FormattedMessage id={msg} />
              </React.Fragment>
            }
          />
        )}
      />

      <ErrorMessage
        name={`${day}.close`}
        render={msg => (
          <ErrorRow
            msg={
              <React.Fragment>
                <FormattedMessage id="closes_at" />:
                <FormattedMessage id={msg} />
              </React.Fragment>
            }
          />
        )}
      />
    </React.Fragment>
  );
};

OpeningTimesRow.propTypes = {
  day: PropTypes.string.isRequired,
  open: PropTypes.string.isRequired,
  close: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export default OpeningTimesRow;



// WEBPACK FOOTER //
// ../ui-components/components/DealerOpeningTimes/OpeningTimesRow.jsx